import React, { Suspense, useRef, useState } from 'react';
import { useVisibility } from '@wearejh/react-hooks/lib/useVisibility';

import { GoogleMap } from 'src/components/GoogleMaps/GoogleMaps';
import { BranchLocationQueryProvider } from 'src/components/StoreLocator/BranchLocationQuery';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { MapType } from './mapConfigAggregator';

type PageBuilderMapProps = MapType;

/**
 * Return the PB Map
 * @param props
 * @constructor
 */
export function PageBuilderMap(props: PageBuilderMapProps) {
    /**
     * Lazy load the ProductGrid and ProductCarousel components
     */
    const ref = useRef<HTMLDivElement | null>(null);
    const [isReady, setReady] = useState(false);
    const options: IntersectionObserverInit = {
        rootMargin: '75px',
    };
    useVisibility(ref, setReady, options);

    /**
     * Configure the styles requires for the Map Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderMapProps>(props);

    const mapClassNames = ['pageBuilderMapGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        mapClassNames.push(...props.cssClasses);
    }

    const locations = props.locations?.map((location) => {
        return {
            name: location.location_name || '',
            county: location.country || '',
            telephone: location.phone || '',
            latitude: location.position?.latitude || 0,
            longitude: location.position?.longitude || 0,
            address: location.address || '',
            city: location.city || '',
            state: location.state || '',
            id: location.record_id ? String(location.record_id) : '',
        };
    });

    /**
     * Render the Map Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={advancedSettings}
            classNames={mapClassNames}
            ref={ref}
        >
            <BranchLocationQueryProvider>
                <div>
                    {isReady && (
                        <Suspense fallback="...">
                            <GoogleMap locations={locations} height={props.height} />
                        </Suspense>
                    )}
                </div>
            </BranchLocationQueryProvider>
        </PageBuilderElementWrapper>
    );
}
